/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum TypeEnum {
  "CARDS_CTX" = "CARDS_CTX"
}

/**
 * Card verify request details for contextual onboarding
 */

// required attributes
const WalletVerifyRequestContextualCardDetailsR = t.interface({});

// optional attributes
const WalletVerifyRequestContextualCardDetailsO = t.partial({
  type: enumType<TypeEnum>(TypeEnum, "type")
});

export const WalletVerifyRequestContextualCardDetails = t.intersection(
  [
    WalletVerifyRequestContextualCardDetailsR,
    WalletVerifyRequestContextualCardDetailsO
  ],
  "WalletVerifyRequestContextualCardDetails"
);

export type WalletVerifyRequestContextualCardDetails = t.TypeOf<
  typeof WalletVerifyRequestContextualCardDetails
>;
